import { equipmentAPI } from "api";

export const searchEqByDispAPI = (payload, page = 0, size = 0, withoutEquipment =false) => {
    return equipmentAPI.post(`/api/equipmentfordisposal?PageNo=${page}&PageSize=${size}&withoutEquipment=${withoutEquipment}`, payload)
        .then((res) => res);
}
